// Simple token utility with in-memory cache + sessionStorage persistence.
// Rationale: Avoid localStorage (persists across browser restarts) and prefer sessionStorage
// to reduce exposure window. Keep a runtime cache to minimize reads.

const STORAGE_KEY = 'auth_token';

let inMemoryToken: string | null = null;

export function getToken(): string | null {
  if (inMemoryToken) return inMemoryToken;
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    inMemoryToken = stored;
    return stored;
  } catch {
    // sessionStorage may be unavailable (privacy mode). Fall back to memory only.
    return inMemoryToken;
  }
}

// A token awaiting MFA is kept in memory only, so a reload cannot resurrect it as a signed-in session.
export function setToken(token: string | null, persist = true): void {
  inMemoryToken = token;
  try {
    if (token && persist) {
      sessionStorage.setItem(STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Ignore storage errors; we still keep in-memory value.
  }
}
